/* RAYOR Theme JavaScript */

document.addEventListener('DOMContentLoaded', function() {

  // ==================== HEADER SCROLL ====================
  var header = document.querySelector('.rayor-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 60) {
        header.classList.add('rayor-header--scrolled');
      } else {
        header.classList.remove('rayor-header--scrolled');
      }
    }, { passive: true });
  }

  // ==================== MOBILE MENU ====================
  var burger = document.getElementById('burger');
  var mobileNav = document.getElementById('mobile-nav');
  var mnavOverlay = document.getElementById('mnav-overlay');

  function openMnav() {
    burger.classList.add('rayor-header__burger--active');
    mobileNav.classList.add('mnav--open');
    mnavOverlay.classList.add('mnav-overlay--open');
    document.body.style.overflow = 'hidden';
  }
  function closeMnav() {
    burger.classList.remove('rayor-header__burger--active');
    mobileNav.classList.remove('mnav--open');
    mnavOverlay.classList.remove('mnav-overlay--open');
    document.body.style.overflow = '';
  }

  if (burger && mobileNav) {
    burger.addEventListener('click', function() {
      if (mobileNav.classList.contains('mnav--open')) {
        closeMnav();
      } else {
        openMnav();
      }
    });

    if (mnavOverlay) {
      mnavOverlay.addEventListener('click', closeMnav);
    }

    var mobileLinks = mobileNav.querySelectorAll('a');
    for (var ml = 0; ml < mobileLinks.length; ml++) {
      mobileLinks[ml].addEventListener('click', closeMnav);
    }
  }

  // ==================== SCROLL REVEAL ====================
  var revealEls = document.querySelectorAll('.reveal, .reveal-stagger, .reveal-left, .reveal-right, .reveal-scale');

  if (revealEls.length > 0) {
    var revealObserver = new IntersectionObserver(function(entries) {
      for (var e = 0; e < entries.length; e++) {
        if (entries[e].isIntersecting) {
          var cl = entries[e].target.classList;
          if (cl.contains('reveal')) cl.add('reveal--visible');
          if (cl.contains('reveal-stagger')) cl.add('reveal-stagger--visible');
          if (cl.contains('reveal-left')) cl.add('reveal-left--visible');
          if (cl.contains('reveal-right')) cl.add('reveal-right--visible');
          if (cl.contains('reveal-scale')) cl.add('reveal-scale--visible');
          revealObserver.unobserve(entries[e].target);
        }
      }
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });

    for (var r = 0; r < revealEls.length; r++) {
      revealObserver.observe(revealEls[r]);
    }
  }

  // ==================== SMOOTH SCROLL ====================
  var anchors = document.querySelectorAll('a[href^="#"]');
  for (var a = 0; a < anchors.length; a++) {
    anchors[a].addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

});
